import { useState, useEffect } from "react";
import { get } from "@/shared/utils/fetchApi";
import {
  DynamicFieldsConfig,
  SettingsResponse,
} from "@/shared/types/dynamic-fields-types";

export const useOnboardingSurvey = () => {
  const [config, setConfig] = useState<DynamicFieldsConfig | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        setIsLoading(true);
        setError(null);

        // v2 não expõe GET /settings/type/:type pra user comum (superadmin) —
        // lista filtrada devolve as rows flat (mesma shape do `data` legacy)
        const items = await get<SettingsResponse["data"][]>(
          "/settings?type=onboarding_survey",
        );
        const data = items?.find((i) => i.type === "onboarding_survey");

        if (data?.fields) {
          setConfig(data.fields);
        } else {
          // Se não houver configuração, retornar config vazia
          setConfig({ schema_version: "1.0", fields: [] });
        }
      } catch (err) {
        // A falha vira estado (`error`) e o onboarding segue sem o survey: a
        // pesquisa é opcional e não pode travar a entrada do usuário.
        setError(
          err instanceof Error ? err.message : "Erro ao carregar pesquisa",
        );
        // Falhar silenciosamente e continuar sem o survey
        setConfig({ schema_version: "1.0", fields: [] });
      } finally {
        setIsLoading(false);
      }
    };

    fetchConfig();
  }, []);

  return { config, isLoading, error };
};
